import { render } from "./ChannelChoiceAC.vue?vue&type=template&id=b742c93a&scoped=true"
import script from "./ChannelChoiceAC.vue?vue&type=script&lang=js"
export * from "./ChannelChoiceAC.vue?vue&type=script&lang=js"

import "./ChannelChoiceAC.vue?vue&type=style&index=0&id=b742c93a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b742c93a"]])

export default __exports__